/* Ampd: Contact page
   1. Live open/closed status for the showroom and for phone/SMS/email support,
      in the showroom's time zone. Honours closure dates and early finishes.
   2. Highlights today's row and hides closures that have passed.
   3. Topic chips reveal help and only the extra fields that topic needs.
      Hidden fields are disabled so they never submit.
   4. ?topic=warranty-service preselects a topic (link from other pages).
   5. Moves focus to the error summary or sent message after a post. */
(function () {
  'use strict';

  var DAYS = ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun'];
  var LABELS = { shop: 'Showroom', sup: 'Phone, SMS & email support' };
  var SHORT = { shop: 'Showroom', sup: 'Support' };

  function toMins(t) {
    if (!t) return null;
    var p = String(t).split(':');
    var h = parseInt(p[0], 10);
    var m = parseInt(p[1] || '0', 10);
    return isNaN(h) ? null : h * 60 + (isNaN(m) ? 0 : m);
  }

  function nowIn(tz) {
    try {
      var parts = new Intl.DateTimeFormat('en-US', {
        timeZone: tz, weekday: 'short', year: 'numeric', month: '2-digit', day: '2-digit',
        hour: 'numeric', minute: 'numeric', hourCycle: 'h23'
      }).formatToParts(new Date());
      var o = {};
      parts.forEach(function (x) { o[x.type] = x.value; });
      return {
        day: DAYS.indexOf(o.weekday),
        date: o.year + '-' + o.month + '-' + o.day,
        mins: (parseInt(o.hour, 10) % 24) * 60 + parseInt(o.minute, 10)
      };
    } catch (e) {
      return null;
    }
  }

  function addDays(ymd, k) {
    var d = new Date(ymd + 'T00:00:00Z');
    d.setUTCDate(d.getUTCDate() + k);
    return d.toISOString().slice(0, 10);
  }

  function shortDate(ymd) {
    try {
      return new Intl.DateTimeFormat('en-AU', { timeZone: 'UTC', weekday: 'long', day: 'numeric', month: 'short' })
        .format(new Date(ymd + 'T00:00:00Z'));
    } catch (e) { return ymd; }
  }

  function initStatus(root) {
    var rows = Array.prototype.slice.call(root.querySelectorAll('[data-ampd-day]'));
    if (rows.length !== 7) return;
    var tz = root.getAttribute('data-tz') || 'Australia/Brisbane';

    var closures = {};
    var src = root.querySelector('[data-ampd-closures]');
    if (src) {
      try {
        JSON.parse(src.textContent).forEach(function (c) { if (c && c.date) closures[c.date] = c; });
      } catch (e) {}
    }

    // Hours for one schedule on one date, after closures are applied
    function hoursOn(kind, dayIdx, ymd) {
      var d = rows[dayIdx].dataset;
      var o = toMins(d[kind + 'Open']);
      var c = toMins(d[kind + 'Close']);
      var res = { open: o, close: c, openLabel: d[kind + 'OpenLabel'], closeLabel: d[kind + 'CloseLabel'], closure: closures[ymd] || null };
      if (o === null || c === null) { res.closed = true; return res; }
      if (res.closure) {
        var early = toMins(res.closure.close);
        if (early === null || early <= o) { res.closed = true; return res; }
        if (early < c) { res.close = early; res.closeLabel = res.closure.closeLabel; res.early = true; }
      }
      return res;
    }

    function statusFor(kind, n) {
      var today = hoursOn(kind, n.day, n.date);
      var name = SHORT[kind];

      if (!today.closed && n.mins >= today.open && n.mins < today.close) {
        var soon = today.close - n.mins <= 30;
        var txt = soon ? name + ' closes soon, at ' + today.closeLabel : name + ' open now until ' + today.closeLabel;
        if (today.early) txt += ' today (' + today.closure.name + ')';
        return { open: true, text: txt };
      }

      var base = name + ' closed';
      if (today.closure && (today.closed || n.mins >= today.close)) {
        base += today.early ? ' from ' + today.closeLabel + ' today (' + today.closure.name + ')' : ' today (' + today.closure.name + ')';
      }

      for (var k = 0; k <= 21; k++) {
        var ymd = addDays(n.date, k);
        var h = hoursOn(kind, (n.day + k) % 7, ymd);
        if (h.closed) continue;
        if (k === 0 && n.mins >= h.open) continue;
        var when = k === 0 ? 'today' : k === 1 ? 'tomorrow' : k <= 6 ? rows[(n.day + k) % 7].dataset.name : shortDate(ymd);
        return { open: false, text: base + '. Opens ' + when + ' at ' + h.openLabel + '.' };
      }
      return { open: false, text: base + '.' };
    }

    function render() {
      var n = nowIn(tz);
      if (!n || n.day < 0) return;

      rows.forEach(function (r, i) {
        var isToday = i === n.day;
        r.classList.toggle('is-today', isToday);
        if (isToday) r.setAttribute('aria-current', 'date'); else r.removeAttribute('aria-current');
      });

      ['shop', 'sup'].forEach(function (kind) {
        var st = statusFor(kind, n);
        Array.prototype.forEach.call(root.querySelectorAll('[data-ampd-status="' + kind + '"]'), function (el) {
          var t = el.querySelector('[data-ampd-status-text]');
          if (t) t.textContent = st.text;
          el.classList.toggle('is-open', st.open);
          el.hidden = false;
        });
      });

      // Upcoming closures: drop past dates, show the next three
      var list = root.querySelector('[data-ampd-closure-list]');
      if (list) {
        var shown = 0;
        Array.prototype.forEach.call(list.querySelectorAll('li[data-date]'), function (li) {
          var future = li.getAttribute('data-date') >= n.date;
          li.hidden = !future || shown >= 3;
          if (future && shown < 3) shown++;
        });
        list.hidden = shown === 0;
      }
    }

    render();
    root._ampdTimer = window.setInterval(render, 60000);
  }

  function initTopics(root) {
    var form = root.querySelector('[data-ampd-form]');
    if (!form) return;
    var radios = Array.prototype.slice.call(form.querySelectorAll('input[name="contact[topic]"]'));
    if (!radios.length) return;
    var fields = Array.prototype.slice.call(form.querySelectorAll('[data-ampd-field]'));
    var panels = Array.prototype.slice.call(form.querySelectorAll('[data-ampd-help]'));

    function update() {
      var sel = null;
      radios.forEach(function (r) {
        if (r.checked) sel = r;
        var chip = r.closest('.ampd-contact__chip');
        if (chip) chip.classList.toggle('is-checked', r.checked);
      });
      var ask = sel ? (sel.dataset.ask || '').split(/\s+/).filter(Boolean) : [];

      panels.forEach(function (p) { p.hidden = !sel || p.id !== sel.dataset.panel; });

      fields.forEach(function (f) {
        var on = ask.indexOf(f.dataset.ampdField) > -1;
        f.hidden = !on;
        Array.prototype.forEach.call(f.querySelectorAll('input, select, textarea'), function (i) { i.disabled = !on; });
      });
    }

    radios.forEach(function (r) {
      r.addEventListener('change', update);
      var chip = r.closest('.ampd-contact__chip');
      if (chip) {
        r.addEventListener('focus', function () { if (r.matches(':focus-visible')) chip.classList.add('is-focused'); });
        r.addEventListener('blur', function () { chip.classList.remove('is-focused'); });
      }
    });

    var wanted = null;
    try { wanted = new URLSearchParams(window.location.search).get('topic'); } catch (e) {}
    if (wanted && !radios.some(function (r) { return r.checked; })) {
      var match = radios.filter(function (r) { return r.dataset.handle === wanted.toLowerCase(); })[0];
      if (match) match.checked = true;
    }

    update();
  }

  function initFocus(root) {
    var el = root.querySelector('[data-ampd-focus]');
    if (!el) return;
    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    el.focus({ preventScroll: true });
    el.scrollIntoView({ block: 'center', behavior: reduce ? 'auto' : 'smooth' });
  }

  function init(root) {
    if (!root || root.dataset.ampdReady) return;
    root.dataset.ampdReady = '1';
    initStatus(root);
    initTopics(root);
    initFocus(root);
  }

  function initAll(scope) {
    Array.prototype.forEach.call((scope || document).querySelectorAll('[data-ampd-contact]'), init);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { initAll(); });
  else initAll();

  // Theme editor support
  document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
  document.addEventListener('shopify:section:unload', function (e) {
    var root = e.target.querySelector('[data-ampd-contact]');
    if (root && root._ampdTimer) window.clearInterval(root._ampdTimer);
  });
})();
